import { InjectionToken } from '@angular/core';

export const EL_STEPPER = new InjectionToken('Endlessjs Stepper Component');
